// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"40636ba9","162":"40636ba9"}[chunkId] + ".chunk.css";
};